<div class="c-cardBox">
  <div class="c-cardBox_head">
    <p class="m-paragraph--fixedSmall">
      Termina em: <strong>5d 19h 33m 03s</strong>
    </p>

    <button class="c-cardBox_head_btn">
      <span class="c-cardBox_head_liked">20</span>
      <svg class="c-cardBox_head_icon c-icon">
        <use xlink:href="#ic-heartFull" />
      </svg>
    </button>
  </div>

  <figure class="c-cardBox_figure">
    <img alt="" class="c-cardBox_img" [src]="data.image" (error)="onImgError($event)" />
  </figure>

  <div class="c-cardBox_content">
    <h4 class="c-cardBox_title">1982 Federico Paternina Centenary Edition (bottled in 1996) - Rioja ...</h4>
  </div>

  <div class="c-cardBox_footer">
    <a class="m-button">Ver lotes</a>
  </div>
</div>
